import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle } from "vue"

import { withDefaults } from "vue";
import StepBox from "@/activity/components/StepTree/StepBox.vue";
import RouterBox from "@/activity/components/StepTree/RouterBox.vue";

interface Props {
  steps: any;
  listIndex: string;
  logs: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'StepTree',
  props: {
    steps: { default: [] },
    listIndex: { default: "" },
    logs: { default: [] }
  },
  emits: ["open"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

function isRouterStep(step: any): boolean {
  if (!step) return false;
  return (
    String(step.name ?? "").toLowerCase() === "router" ||
    String(step.type ?? "").toLowerCase() === "router"
  );
}

function openDrawer(step, insideRouter, stepBoxRef) {
  emit("open", step, insideRouter, stepBoxRef);
}

return (_ctx: any,_cache: any) => {
  const _component_StepTree = _resolveComponent("StepTree", true)!

  return (_openBlock(), _createElementBlock("div", {
    class: "step-tree-container",
    style: _normalizeStyle(`grid-template-columns: repeat(${_ctx.steps?.length}, 210px [col-start])`)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps?.filter((s) => s), (step, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: step?.id || step?.uniqueId || index,
        class: "step-tree-item"
      }, [
        (!isRouterStep(step))
          ? (_openBlock(), _createBlock(StepBox, {
              key: 0,
              index: index,
              step: step,
              log: props.logs?.find((x) => x?.stepId === step?.id),
              listIndex: _ctx.listIndex,
              onOpen: openDrawer
            }, null, 8, ["index", "step", "log", "listIndex"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(RouterBox, {
                listIndex: _ctx.listIndex,
                step: step
              }, null, 8, ["listIndex", "step"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step?.routes, (route, routeIndex) => {
                return (_openBlock(), _createElementBlock("div", { key: routeIndex }, [
                  _createVNode(_component_StepTree, {
                    steps: route.steps,
                    logs: props.logs,
                    "list-index": `${_ctx.listIndex}-${routeIndex}`,
                    onOpen: openDrawer
                  }, null, 8, ["steps", "logs", "list-index"])
                ]))
              }), 128))
            ], 64))
      ]))
    }), 128))
  ], 4))
}
}

})